import React, {useContext, useEffect} from "react";
import {Route as ReactRoute} from "react-router-dom";
import {LocaleContext} from "../../../store/providers/LocaleProvider";
import {useAnalytics} from "../../../store/providers/AnalyticsProvider";
import {RouteContext} from "../../../store/providers/RouteProvider";
import { SEO as Seo } from "@hapinest/theme";

const Route = ({...props}) => {
    const {locale} = useContext(LocaleContext)[0];
    const {setPrivateRoute} = useContext(RouteContext);
    const {sendPageView} = useAnalytics();

    useEffect(() => {
        setPrivateRoute(props?.isPrivate || false);
    }, [props?.isPrivate]);

    useEffect(() => {
        if(!props?.skipPageView && sendPageView) {
            const type = props?.type || props?.path.replace("/" + locale + "/", "").replace(/\/+$/, "");
            if(type?.indexOf("*") === -1) {
                sendPageView({
                    page_type: type,
                    ...Boolean(props?.title) && {page_title: props?.title}
                });
            }
        }
    }, [sendPageView]);

    return (
        <>
            <Seo title={props?.seoTitle} />
            <ReactRoute
                {...props}
            />
        </>
    );
};

export default Route;
